<div class="grid grid-cols-1 sm:grid-cols-4 gap-6 w-full min-w-0 p-5">
    <!-- Total Wll Management Monitoring Index -->
    <monitoring-index class="sm:col-span-2 lg:col-span-2 bg-card shadow rounded-2xl overflow-hidden"
        [expandIcon]="expandIcon"></monitoring-index>

    <!-- Unhealthy Wells -->
    <unhealthy-wells class="sm:col-span-2 lg:col-span-2 bg-card shadow rounded-2xl overflow-hidden"
        [data]="unhealthyWellsData" [expandIcon]="expandIcon"></unhealthy-wells>

    <!-- Well Maintenance Plan vs Actual -->
    <well-maintenance class="sm:col-span-2 lg:col-span-2 bg-card shadow rounded-2xl overflow-hidden"
        [data]="wellMaintenanceData" [expandIcon]="expandIcon">
    </well-maintenance>

    <!-- Well Integrtiy Remarks -->
    <well-remarks class="sm:col-span-2 lg:col-span-2 bg-card shadow rounded-2xl overflow-hidden"
        [data]="wipRemarkData"></well-remarks>

    <!-- Remedial Progress -->
    <remedial-progress class="sm:col-span-2 lg:col-span-2 bg-card shadow rounded-2xl overflow-hidden"
        [data]="remedialProgressData" [expandIcon]="expandIcon"></remedial-progress>

    <!-- Other Activities -->
    <activities class="sm:col-span-2 lg:col-span-2 bg-card shadow rounded-2xl overflow-hidden"
        [data]="otherActivitiesData" [expandIcon]="expandIcon"></activities>
</div>

<ng-template #expandIcon>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 28" stroke-width="1.5" stroke="#ffff"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round"
            d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15" />
    </svg>
</ng-template>